import { useState } from 'react'

import { Container } from '@twistopayments/design-system/components/atoms/container'
import { Modal } from '@twistopayments/design-system/components/atoms/modal'
import { Typography } from '@twistopayments/design-system/components/atoms/typography'
import { PlayIcon } from '@twistopayments/design-system/icons/inline'

import type {
  BlocksVideoStoryComponent,
  SectionsVideoStoriesComponent,
} from '@twisto/api-cms'
import { useOpen } from '@twisto/hooks'

import { AccessibleDiv, StrapiMedia } from 'homepage/components/atoms'

import * as styles from './video-stories.styles'
import { PlayButton } from './video-stories.styles'

type Video = BlocksVideoStoryComponent['video']

export const VideoStories = ({
  title,
  subtitle,
  items,
}: SectionsVideoStoriesComponent) => {
  const { isOpen, handleOpen, handleClose } = useOpen()
  const [selectedVideo, setSelectedVideo] = useState<Video | null>(null)

  const handleOpenModal = (video?: Video) => {
    if (!video) {
      return
    }
    setSelectedVideo(video)
    handleOpen()
  }

  return (
    <Container as="section" id="video-stories" size="wider">
      <Typography align="center" color="primary" fontWeight="heavy">
        {subtitle}
      </Typography>
      <Typography align="center" fontWeight="heavy" variant="h1">
        {title}
      </Typography>

      {items && (
        <ul css={styles.storiesContainer}>
          {items.map(({ previewImage, id, headline, text, video }) => (
            <AccessibleDiv
              key={id}
              as="li"
              css={styles.story}
              role="button"
              onActivate={() => handleOpenModal(video)}
            >
              <StrapiMedia {...previewImage} />

              <p css={styles.storyInfo}>
                <Typography component="span" fontWeight="heavy">
                  {headline}
                </Typography>
                <Typography component="span">{text}</Typography>
              </p>

              <PlayButton>
                <PlayIcon />
              </PlayButton>
            </AccessibleDiv>
          ))}
        </ul>
      )}

      <Modal
        noPadding
        withoutAnimation
        aria-label="video-stories"
        autoWidth={false}
        modalWrapperStyles={styles.video}
        opened={isOpen}
        onClickOutside={handleClose}
        onClose={handleClose}
      >
        {selectedVideo && (
          <StrapiMedia {...selectedVideo} controls muted={false} />
        )}
      </Modal>
    </Container>
  )
}
